import { Stack } from "@mui/material";
import { AutocompleteInput, ReferenceInput, required } from "react-admin";
import { FranceGroupTypeEnum } from "shared/enums/globalEnums";
import { SiteResourcesEnum } from "shared/enums/resourceMappings";
import { validateStartDate } from "shared/utils/validations";
import CustomDateTimeInput from "shared/components/inputs/CustomDateTimeInput";

const FormHeader = () => {
  return (
    <Stack direction="row" spacing={2} width={"100%"} alignItems={"center"}>
      <ReferenceInput
        label="EDP"
        source="group_id"
        reference={SiteResourcesEnum.Groups}
        filter={{ type: FranceGroupTypeEnum.rte_edr }}
      >
        <AutocompleteInput
          validate={[required()]}
          optionText={(record) => `(id: ${record.id}) ${record.name} ${record.code} - MODE: ${record.mode}`}
        />
      </ReferenceInput>

      <CustomDateTimeInput
        label={"Start date"}
        source="startingDate"
        parse={(value) => new Date(value)}
        validate={[required(), validateStartDate]}
      />
    </Stack>
  );
};

export default FormHeader;
